<user-recurring-mobile *ngIf="isMobile"></user-recurring-mobile>
<user-recurring-desktop *ngIf="!isMobile"></user-recurring-desktop>